// Tap-to-copy discount ticket, shared by the collection campaign strip and the
// in-grid clearance tile (the cart reuses it later). The code is NEVER
// auto-applied — copying is the whole interaction (locked decision). The label
// flips to "Copied ✓" for 1.6s; clipboard failures still flip the label so the
// customer knows the tap registered and can select the text manually.
class LettoriaCopyCode extends HTMLElement {
  connectedCallback() {
    this.label = this.querySelector('[ref-copy-label]');
    this.addEventListener('click', () => this.copy());
  }

  copy() {
    const code = this.getAttribute('data-code') || '';
    const done = () => this.flash();
    if (navigator.clipboard && code) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      done();
    }
  }

  flash() {
    if (!this.label) return;
    const idle = this.label.getAttribute('data-idle-label') || this.label.textContent;
    this.label.setAttribute('data-idle-label', idle);
    this.label.textContent = 'Copied ✓';
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.label.textContent = idle;
    }, 1600);
  }
}

if (!customElements.get('lettoria-copy-code')) {
  customElements.define('lettoria-copy-code', LettoriaCopyCode);
}
